const footerContainer = document.createElement("div");

(function () {
  // Step 1 get data from 148 ad position
  if (typeof window.coeFooterData == "undefined" || document.getElementById("ads-pos-148") == null) {
    return;
  }
  const _relLinks = document.getElementById("rel-links");
  if (_relLinks && document.getElementById("rel-links") != null) {
    _relLinks.style.display = "none";
  }
  // insert new coeFooter container
  footerContainer.setAttribute("class", "newcoeFooter");
  footerContainer.innerHTML = `
  <div class="newcoeFooter-header">
    <span class="newcoeFooter-header-bookmark"></span>
    <div>
      <span class="newcoeFooter-header-text">More from the Center of Excellence</span>
      <a class="newcoeFooter-header-title" href="${urlIsAbsolute(window.coeFooterData["coe-url"])? window.coeFooterData["coe-url"]:reformUrls(window.coeFooterData["coe-url"])}">${window.coeFooterData["coe-name"]}</a>
    </div>
  </div>
  <div id="newcoeFooter-body" class="newcoeFooter-body">
  </div>
  `;

  if (typeof mscpA2A == 'boolean' && mscpA2A) {
	if (window.coeFooterData['lead-concept'] == infMetaRespObj[currSlctCont].pageSegVars.scg && document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] [id*=ads-pos-148]') != null && document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] .newcoeFooter') == null) {
		document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] [id*=ads-pos-148]').after(footerContainer);
	} else {
		return;
	}
  } else {
    document.getElementById("ads-pos-148").after(footerContainer);
  }
  //document.getElementById("footercontents").append(footerContainer);
  customAdsEventListener();
  addCssForCOE();
  const relativePath = window.location.origin;
  const api_url = `${relativePath}/api/v1/search/profnewsref?q=leadConceptId:${
    window.coeFooterData["lead-concept"]
  }&rows=3`;
  const api_url_2 = `${relativePath}/api/v1/search/profnewsref?q=leadConceptId:${
    window.coeFooterData["coe-lead-concept"]
  }&rows=3`;
  let mainArticle = [];
  let relatedArticles = [];
  fetchApiLeadConcept(api_url_2).then((e) => {
    if (e.data.length > 0) {
      mainArticle = e.data;
    }
    fetchApiLeadConcept(api_url).then((e) => {
      if (e.data.length > 0) {
        relatedArticles = e.data;
      }
      const hhtml = createCoeHtml(mainArticle, relatedArticles);
      add424AdPos();
    });
  }).catch((_e)=>{
    fetchApiLeadConcept(api_url).then((e) => {
      if (e.data.length > 0) {
        relatedArticles = e.data;
      }
      const hhtml = createCoeHtml(mainArticle, relatedArticles);
      add424AdPos();
    });
  })
})();

function addCssForCOE() {
  var head = document.getElementsByTagName("HEAD")[0];
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = `//img.${getCoeDomain()}medscapestatic.com/medscape-core/www/css/article/coe-footer.css`;
  head.appendChild(link);
  return;
}

function fetchApiLeadConcept(api_url) {
  return fetch(api_url)
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
}

function getCoeDomain() {
  const hostname = window.location.host.split(".");
  if (hostname.indexOf("qa01") > -1) {
    return "qa01.";
  } else if (hostname.indexOf("staging") > -1) {
    return "staging.";
  } else {
    return "";
  }
}

function createCoeHtml(mainArticles, relatedArticles) {
  let _html = "";
  if(mainArticles.length == 0 && relatedArticles.length == 0) {
    return _html;
  } else if(mainArticles.length > 0 && relatedArticles.length > 1) {
    _html = createArticleHtml(mainArticles[0], relatedArticles[0], relatedArticles[1]);
  } else if(mainArticles.length == 0 && relatedArticles.length > 2) {
    _html = createArticleHtml(relatedArticles[0], relatedArticles[1], relatedArticles[2]);
  } else if(mainArticles.length > 2 && relatedArticles.length == 0) {
    _html = createArticleHtml(mainArticles[0], mainArticles[1], mainArticles[2]);
  }
  
  footerContainer.querySelector('#newcoeFooter-body').innerHTML = _html;
  return _html;
}


function getCoeDate(_e) {
  const date = new Date(_e);
  return date.toDateString();
}

function createArticleHtml(_coe, _related1, _related2) {
  const _sponsored = _coe["supprtrGrantBadge_s"]
      ? `<div class="newcoeFooter-body-collaboration">
    <span class="newcoeFooter-body-collaboration-text">Collaboration</span>
    <img class="newcoeFooter-body-collaboration-logo" src="${_coe["supprtrGrantBadge_s"]}">
  </div>`
      : "";
  const _img = _coe["multimedia"] && _coe["multimedia"][0] ? `<img class="newcoeFooter-body-c1-img"
  src="https://img.${getCoeDomain()}medscapestatic.com${_coe["multimedia"][0]}" />` : "";
  const _pubDisplay1 = _coe["pubDisplay"]
  ? `<div class="newcoeFooter-body-c1-article-byline">
  <span class="newcoeFooter-body-c1-article-byline-publication">${_coe["pubDisplay"]} |</span>
  <span class="newcoeFooter-body-c1-article-byline-timestamp">
    ${getCoeDate(_coe["publicationDate"])}
  </span>
</div>

`
  : "";
  const firstHtml = `<div class="newcoeFooter-body-c1 ">
  <div class="${_sponsored ? 'sponsored-content' : ''}">
    ${_img}
    ${_sponsored}
    <a class="newcoeFooter-body-c1-title ${_sponsored ? 'sponsor-padding' : ''}" href=${_coe["clientUrl"]}>
    ${_coe["title"]}
    </a>
    ${_sponsored ? "" : _pubDisplay1}
    </div>
  </div>`;

    const relatedArticles1 = _related1;
    const relatedArticles2 = _related2;
    const pubDisplay1 = relatedArticles1["pubDisplay"]
      ? `<span class="newcoeFooter-body-c2-article-byline-publication">
     ${relatedArticles1["pubDisplay"]} |
  </span>`
      : "";
    const pubDisplay2 = relatedArticles2["pubDisplay"]
      ? `<span class="newcoeFooter-body-c2-article-byline-publication">
    ${relatedArticles2["pubDisplay"]} |
 </span>`
      : "";

    const secondHtml = `<div class="newcoeFooter-body-c2">
    <div class="newcoeFooter-body-c2-article first">
      <a class="newcoeFooter-body-c2-article-title" href="${relatedArticles1["clientUrl"]}">
        ${relatedArticles1["title"]}
      </a>
      <div class="newcoeFooter-body-c2-article-byline">
        ${pubDisplay1}
        <span class="newcoeFooter-body-c2-article-byline-timestamp">
          ${getCoeDate(relatedArticles1["publicationDate"])}
        </span>
      </div>
    </div>
    <div class="newcoeFooter-body-c2-article second" id="CoeFooterThirdElem" style="display: flex;">
      <a class="newcoeFooter-body-c2-article-title" href="${relatedArticles2["clientUrl"]}">
      ${relatedArticles2["title"]}
      </a>
      <div class="newcoeFooter-body-c2-article-byline">
      ${pubDisplay2}
        <span class="newcoeFooter-body-c2-article-byline-timestamp">
          ${getCoeDate(relatedArticles2["publicationDate"])}
        </span>
      </div>
    </div>
  </div>`;
    return firstHtml + secondHtml;
}

function add424AdPos () {
  let _targetElem = document.getElementsByClassName("newcoeFooter-body-c2-article")[0];
  if (typeof mscpA2A == 'boolean' && mscpA2A) {
	  _targetElem = document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] .newcoeFooter-body-c2-article');
  }
  if(_targetElem) {
  let adsDiv = document.createElement("div");
  let pushedAd = 'ads-pos-424';
  if (typeof mscpA2A == 'boolean' && mscpA2A) {
		pushedAd = 'ads-pos-424-' + currSlctCont.match(/[^/-]+$/)[0];
  }
  if(typeof breakpoint === "number" && breakpoint == "1") {
    pushedAd = "ads-pos-1424";
	if (typeof mscpA2A == 'boolean' && mscpA2A) {
		pushedAd = 'ads-pos-1424-' + currSlctCont.match(/[^/-]+$/)[0];
	}
    adsDiv.setAttribute("id", pushedAd);
    _targetElem.parentNode.insertBefore(adsDiv, _targetElem.nextSibling);
    webmd.ads2.defineAd({ id: pushedAd, pos: '1424', refresh: false });
	let adObj = {};
	adObj[pushedAd] = true;
    webmd.ads2.refresh({id: adObj});
  } else {
    adsDiv.setAttribute("id", pushedAd);
    _targetElem.parentNode.insertBefore(adsDiv, _targetElem.nextSibling);
    webmd.ads2.defineAd({ id: pushedAd, pos: '424', refresh: false });
    let adObj = {};
	adObj[pushedAd] = true;
    webmd.ads2.refresh({id: adObj});
  }
  webmd.ads2.addSlotRenderEndedCallback(pushedAd,function (params) {
    const CoeFooterThirdElem = _targetElem.parentNode.querySelector("#CoeFooterThirdElem");
    if(!CoeFooterThirdElem) return;   
    setTimeout(function () {
      CoeFooterThirdElem.style.display = (adsDiv.className.indexOf("blank-ad") > -1 || adsDiv.style.display == 'none') ? "flex": "none";
    }, 1000);
  });
  } else {
    console.error("Target element not found cannot add 424/1424");
  }
}

function reformUrls(_url) {
  return `https://www.${getCoeDomain()}medscape.com${_url}`
}

function urlIsAbsolute(urlString) {
  var pat = /^https?:\/\//i;
  if (pat.test(urlString)) {
    return true;
  }
  return false;
}
function customAdsEventListener () {
  document.addEventListener("collapse", function(event) {
    if(event.detail && (event.detail.iframe == "ads-pos-424" || event.detail.iframe == "ads-pos-1424")) {
      const CoeFooterThirdElem = document.getElementById("CoeFooterThirdElem");
      if (CoeFooterThirdElem) {
        CoeFooterThirdElem.style.display = "flex";
      }
    }
  });
}
